import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { CONTACT, SERVICES } from "@/lib/site";

export default function Footer() {
  return (
    <footer className="bg-navy text-ivory" data-testid="site-footer">
      <div className="shell grid gap-12 py-16 md:grid-cols-[1.2fr_1fr_1fr] md:py-20">
        <div>
          <div className="inline-block bg-ivory px-4 py-3">
            <img
              src="/images/riverstone-logo.webp"
              alt="Riverstone Partners"
              width="2000"
              height="668"
              className="h-10 w-auto"
              data-testid="footer-logo"
            />
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-ivory/70">
            Business solutions. Lasting partnerships. Riverstone Partners helps you
            explore practical solutions aligned with your priorities — and connects
            you with the right specialists to move forward.
          </p>
          <a
            href={CONTACT.phoneHref}
            data-testid="footer-phone-link"
            className="mt-6 inline-flex min-h-[44px] items-center gap-2 text-sm text-ivory/85 transition-colors hover:text-ivory"
          >
            <Phone className="h-4 w-4 text-river" />
            {CONTACT.phone}
          </a>
        </div>

        <nav aria-label="Footer — solutions">
          <p className="eyebrow text-river">Solutions</p>
          <ul className="mt-5 space-y-3">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/solutions/${s.slug}`}
                  className="text-sm text-ivory/75 transition-colors hover:text-ivory"
                >
                  {s.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/solutions" className="text-sm text-ivory/75 transition-colors hover:text-ivory">
                All Solutions
              </Link>
            </li>
          </ul>
        </nav>

        <nav aria-label="Footer — company">
          <p className="eyebrow text-river">Company</p>
          <ul className="mt-5 space-y-3">
            {[
              ["Our Approach", "/approach"],
              ["About Riverstone", "/about"],
              ["Become a Partner", "/become-a-partner"],
              ["Contact", "/contact"],
              ["Privacy Policy (Draft)", "/privacy"],
              ["Terms of Service (Draft)", "/terms"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-sm text-ivory/75 transition-colors hover:text-ivory">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>

      <div className="border-t border-ivory/10">
        <div className="shell flex flex-col items-start justify-between gap-3 py-6 text-xs text-ivory/50 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Riverstone Partners. All rights reserved.</p>
          <p>
            Riverstone introduces businesses to independent solution providers; delivery
            is performed by those providers.
          </p>
        </div>
      </div>
    </footer>
  );
}
